module.exports = __webpack_public_path__ + "static/media/congrats-achivement.afd31dea.png";